'use client';

import Link from 'next/link';
import Script from 'next/script';
import { useEffect, useState } from 'react';

interface InstagramEmbedProps {
    url: string;
    className?: string;
}

const InstagramEmbed = ({ url, className }: InstagramEmbedProps) => {

    const [scriptLoaded, setScriptLoaded] = useState<boolean>(false);

    useEffect(() => {
        if (scriptLoaded && window?.instgrm?.Embeds) {
            window.instgrm.Embeds.process();
        }
    }, [scriptLoaded, url]);

    return (
        <div className={className}>
            <blockquote
                className="instagram-media"
                data-instgrm-permalink={url}
                data-instgrm-version="14"
                style={{
                    width: '100%',
                    maxWidth: '540px',
                    margin: '0 auto'
                }}
            >
                <Link href={url} target='_blank' prefetch={false}>{url}</Link>
            </blockquote>
            <Script
                src="https://www.instagram.com/embed.js"
                strategy="afterInteractive"
                onLoad={() => setScriptLoaded(true)}
            />
        </div>
    );
};

export default InstagramEmbed;